import { CSSInterpolation } from '@mui/system';
import colors from '../../base/colors';

const root = {} as CSSInterpolation;

const sizeSmall = {} as CSSInterpolation;

const sizeMedium = {
  height: '40px',
} as CSSInterpolation;

export default {
  root,
  sizeSmall,
  sizeMedium,
};
